Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'

module.exports = class SelectBackgroundView extends View
  initialize: ->
    super
    @listenTo @model, 'change:error', @render

  className: 'board-background-select js-select-background'

  events:
    'click': 'selectBackground'
    'click .js-background-attribution': 'clickAttribution'

  render: ->
    data = @model.toJSON()
    data.pending = !@getId()? && !data.error?

    if !data.color?
      data.backgroundImageThumbnail =
        Util.previewBetween(@model.get('scaled'), 90, 60, 600, 400)?.url ?
        @model.get('fullSizeUrl')

    @$el.html(
      templates.fill(
        'board_background_selection',
        data
      )
    )

    @$el.toggleClass('is-still-uploading-background', data.pending)

    @

  clickAttribution: (e) ->
    e.stopPropagation()
    track("Board Menu", "Change Background", "Clicked Attribution")

  getId: ->
    @model.get('name')

  selectBackground: (e) ->
    Util.stop(e)
    return if !@getId()?

    board = @options.board
    # Update the local data so we don't have to wait for the server to respond
    _.extend(board.attributes.prefs, {
      backgroundColor: @model.get('color')
      backgroundImage: @model.get('fullSizeUrl')
      backgroundImageScaled: @model.get('scaled')
      backgroundTile: @model.get('tile') ? false
      backgroundBrightness: @model.get('brightness') ? 'unknown'
    })

    board.setPref "background", @getId()

    track("Board Menu", "Change Background", @getId())
    return
